import { AuthService } from '../../../core/auth.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export type Device = {
  idHex: string;
  idDec: number;
};

@Injectable({
  providedIn: 'root',
})
export class DevicesSettingsService {
  devicesUrl = environment.baseUrl + environment.api + 'devices';
  constructor(private http: HttpClient, private authService: AuthService) {}

  getDevices(): Observable<Device[]> {
    return this.http
      .get<number[]>(`${this.devicesUrl}/fleet`, {
        headers: this.authService.getJwtAuthHeaders(),
      })
      .pipe(
        map((devices) =>
          devices.map((device) => ({
            idHex: this.decToHex(device),
            idDec: device,
          }))
        )
      );
  }

  deleteDevice(deviceId: number): Observable<any> {
    return this.http.delete<any>(`${this.devicesUrl}/${deviceId}`, {
      headers: this.authService.getJwtAuthHeaders(),
    });
  }

  addDevice(deviceId: number): Observable<any> {
    return this.http.put<number[]>(`${this.devicesUrl}/${deviceId}`, null, {
      headers: this.authService.getJwtAuthHeaders(),
    });
  }

  private decToHex(value: number): string {
    if (value < 0) {
      value = 0xffff + value + 1;
    }

    return value.toString(16).toUpperCase();
  }
}
